import { ITEM_TYPES, type ItemType } from '@hive/shared';
import type { SearchHit } from '@/data/vault';

/** The types Scan searches, in the order its groups show. */
export const SCAN_TYPES = ITEM_TYPES.filter((t) => t.id !== 'game');

/** Splits a search snippet (matches wrapped in **) into plain and highlighted parts. */
export function snippetParts(snippet: string): { text: string; match: boolean }[] {
  return snippet
    .split('**')
    .map((text, i) => ({ text, match: i % 2 === 1 }))
    .filter((p) => p.text);
}

/** Hits grouped by type in Scan's order, best first within each, empty groups left out. */
export function groupHits(hits: readonly SearchHit[]): { type: ItemType; plural: string; hits: SearchHit[] }[] {
  return SCAN_TYPES.map((t) => ({
    type: t.id,
    plural: t.plural,
    hits: hits.filter((h) => h.item_type === t.id),
  })).filter((g) => g.hits.length > 0);
}

/** Whether a key press opens quick search: Ctrl+K, or Cmd+K on a Mac. */
export function isQuickSearchKey(
  e: Pick<KeyboardEvent, 'key' | 'ctrlKey' | 'metaKey' | 'altKey' | 'shiftKey'>,
): boolean {
  return e.key.toLowerCase() === 'k' && (e.ctrlKey || e.metaKey) && !e.altKey && !e.shiftKey;
}
